import React, { useRef, useState, useEffect } from "react";
import Select from "react-select";
import colourStyles from "./FilterSelectStyles";
import { baseApiInstance, scopeApiInstance } from "../../../../dataProvider/axiosHelper";
import { notification } from "antd";
import { Strings } from "../../../../dataProvider/localize";

export default function RegionStateFilter({ filter, filterValues, onFilterValueChange, defaultData, loading }) {

  const controller = useRef();

  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [region, setRegion] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [loadingRegion, setLoadingRegion] = useState(false);

  useEffect(() => {
    if (filterValues) {
      if (filterValues[filter.stateParam] && filterValues[filter.stateParam] !== selectedState) {
        setSelectedState(filterValues[filter.stateParam]);
      } else {
        if (!filterValues[filter.stateParam]) {
          setSelectedState(null);
        }
      }
      if (filterValues[filter.regionParam] && filterValues[filter.regionParam] !== selectedRegion) {
        setSelectedRegion(filterValues[filter.regionParam]);
      } else {
        if (!filterValues[filter.regionParam]) {
          setSelectedRegion(null);
        }
      }
    }
  }, [filterValues]);

  const getStateValues = () => {
    controller.current = new AbortController();
    return baseApiInstance.get(
      filter.stateEndPoint,
      { params: {}, signal: controller.current.signal },
    ).then(res => {
      if (res && res.data && res.data.data) {
        setStates(res.data.data)
      }
    }).catch(error => {
      if (error) {
        notification.error({
          message: Strings.error_title,
          description: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error,
          className: "ant-error"
        });
      }
    })
  }

  const getRegionValues = (newState) => {
    controller.current = new AbortController();
    return scopeApiInstance.get(
      filter.regionDataEndPoint,
      { params: { states: newState }, signal: controller.current.signal },
    ).then(res => {
      if (res && res.data && res.data.data) {
        setRegion(res.data.data)
      }
      setLoadingRegion(false);
    }).catch(error => {
      if (error) {
        setLoadingRegion(false);
        notification.error({
          message: Strings.error_title,
          description: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error,
          className: "ant-error"
        });
      }
    })
  }

  useEffect(() => {
    getStateValues();
    return () => {
      if (controller.current) {
        controller.current.abort()
      }
    }
  }, []);

  const onStateChange = (newState) => {
    if ((states && newState.value !== states.value) || !states) {
      onFilterValueChange(newState, filter.stateParam);
      setRegion([]);
      onFilterValueChange(null, filter.regionParam);
      setLoadingRegion(true);
      getRegionValues(`["${newState.label}"]`)
    }
  }

  return (
    <>
      <div className="col-2 pb-2">
        <Select
          placeholder="States"
          onChange={(v) => onStateChange(v)}
          value={selectedState}
          options={states.map((x) => ({
            label: x[filter.stateDataLabel],
            value: x[filter.stateDataValue]
          }))}
          hideSelectedOptions={false}
          isMulti={filter.allowMultiple}
          closeOnSelect={!filter.allowMultiple}
          closeMenuOnSelect={!filter.allowMultiple}
          isLoading={loading}
          clearable
          styles={colourStyles}
        />
      </div>
      <div className="col-2 pb-2">
        <Select
          placeholder="Region"
          onChange={(v) => onFilterValueChange(v, filter.regionParam)}
          value={selectedRegion}
          options={region.map((x) => ({
            label: x[filter.regionDataLabel],
            value: x[filter.regionDataValue]
          }))}
          isDisabled={!selectedState}
          hideSelectedOptions={false}
          isMulti={filter.allowMultiple}
          closeOnSelect={!filter.allowMultiple}
          closeMenuOnSelect={!filter.allowMultiple}
          isLoading={loadingRegion}
          clearable
          styles={colourStyles}
        />
      </div>
    </>
  )
}